module.exports = __webpack_public_path__ + "img/22.85c9c8f0.jpg";